import { cloneDeep, isEqual } from 'lodash'

export function useFormModel<T>(model: Ref<T>, initialModelState?: MaybeRefOrGetter<T>) {
  const initialState = ref<T>(cloneDeep(initialModelState ? toValue(initialModelState) : model.value)) as Ref<T>

  function refresh() {
    initialState.value = cloneDeep(model.value)
  }

  function reset() {
    model.value = cloneDeep(initialState.value)
  }

  const edited = computed(() => {
    return !isEqual(initialState.value, model.value)
  })

  return { edited, refresh, reset }
}
